<mat-dialog-content class="accent-color dialogue-content blood-dialogue">
  <div class="patient-history mat-typography">
    <div class="row">
      <div class="large-12 equalize outer-card">
        <div class="description">
          <div class="">
            <p style="text-align:center; display: block; margin: 0 auto;">
              Updated
            </p>
          </div>
        </div>
        <section class="response medication inputs blood">
          <p style="text-align:center; margin-top: 20px;">
            You successfully updated your account to {{new_skillset}}. Any cases you start now will include
            {{skillset_description}}.
          </p>
        </section>
        <section class="actions">
          <button class="action mat-button mat-raised-button mat-primary" [mat-dialog-close]="true">{{btn2text}}
          </button>
        </section>
      </div>
    </div>
  </div>
</mat-dialog-content>
